module.exports = __webpack_public_path__ + "img/match-manage-unit.d5c02df2.png";